<template>
  <f7-page :page-content="false">
    <f7-navbar title="ConfigCombo" :back-link="$t('atras')"></f7-navbar>
    <f7-page-content class="full-height">
      <r-dynamic-list
        ref="rlist"
        :dbAdapter="ConfigCombo"
        :tableCode="'CONFIG_COMBO'"
        :tableMode="true"
        :virtualListParams="{height:32, rowsBefore:60, rowsAfter:60}"
        class="card full-height data-table"
        classContent="card-content full-height"
        :shownFields="['protegidoBorrado']"
        :massiveActions="false"
        :controlsWidth="80"
      >
        <template v-slot:tableLinks>
          <a class="link" href="/configcombo/new/">{{$t('common.nueva')}}</a>
        </template>
        <template v-slot:optionsColumn="{item}">
          <f7-link icon-f7="eye" color="green" :href="`/configcombo/view/${item.id}/`" v-tooltip="$t('common.ver')"></f7-link>
          <f7-link icon-f7="square_pencil" color="blue" :href="`/configcombo/edit/${item.id}/`" v-tooltip="$t('common.editar')"></f7-link>
          <f7-link v-if="!item.protegidoBorrado" icon-f7="trash" color="red" @click="$refs.rlist.deleteItem(item.id)" v-tooltip="$t('common.eliminar')"></f7-link>
          <f7-link v-else icon-f7="lock_fill" color="gray" v-tooltip="'Protegido contra borrado'"></f7-link>
        </template>
      </r-dynamic-list>
    </f7-page-content>
  </f7-page>
</template>

<script>
import rDynamicList from "./../../components/rDynamicList.vue";
import ConfigCombo from "./../../js/db/ConfigCombo.js";

export default {
  components: {
    rDynamicList
  },
  data() {
    return {
      ConfigCombo
    };
  }
};
</script>
